<template>
    <div style="color: #fff; align-self: flex-start;" id="trial-extended-container">
        <div v-if="trialExtended == 0" style="padding: 0 30px; text-align: center;">

            <br/><br/>

            <div style="line-height: 1.6; font-size: 16px; margin-bottom: 8px; text-shadow: 1px 1px 4px #000;">
                Unlock your best with DentiCalc!
                <span style="display: inline-block; line-height: 1.1; margin-top: 5px; margin-bottom: 7px; font-weight: 600; font-size: 24px;">Get a FREE {{extraTrialDays}}-day glimpse of your future!</span>
            </div>

            <br/>
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">
                <v-text-field @focus="handleInputFocus" @blur="handleInputBlur" hide-details style="width: 100%; border-radius: 3px; background: #fff;" type="email" ref="reviewEmail" box id="trial-extend-email-input" v-model="email" placeholder="Your email address" />

                <div :class="showTosAcceptedWarning && !tosAccepted ? 'pm-btn-glowing' : ''" @click.stop="tosAccepted = true;" style="margin-top: 18px; margin-bottom: 8px; padding-top: 8px; border-radius: 10px; padding: 5px 10px;">
                    <mdi v-show="!tosAccepted" @click.native.stop="tosAccepted = true;" style="color: #fff;">mdiCheckboxBlankOutline</mdi>
                    <mdi v-show="tosAccepted" @click.native.stop="tosAccepted = false;" style="color: #fff;">mdiCheckboxMarkedOutline</mdi>
                    Keep me up to date with news and updates. <router-link to="/privacy-policy" style="color: #fff;" v-on:click.native="visible=false">privacy policy.</router-link>
                </div>

                <v-btn class="orange" style="margin-top: 14px; padding: 0px 24px 0 32px; background: #fff; height: 48px!important; border-radius: 26px; border: 1px solid #2962ff; box-shadow: 10px 10px 10px rgba(0,0,0,0.25); color: #fff;" large :loading="processing" @click="send">
                    <span style="text-shadow: 1px 1px 4px rgba(0,0,0,.5); color: #fff; text-transform: uppercase!important; line-height: 1.2; padding-right: 16px; font-weight: 600;">
                        <!-- GIVE ME {{extraTrialDays}} DAYS FREE -->
                        Upgrade me now
                    </span>
                    <v-icon style="text-shadow: 1px 1px 4px rgba(0,0,0,.5); margin-top: -0px;">chevron_right</v-icon>
                </v-btn>



            </div>
        </div>

        <div v-if="trialExtended > 0" style="text-align: center; background-color: #fff; padding: 30px; border-radius: 10px; box-shadow: 0 0 10px rgba(0,0,0,.15);">
            <img src="https://cdn.denticalc.com/images/app-success-2.jpg" style="max-width: 90%;" />
            <br/>
            <span style="font-size: 40px; font-weight: 600; color: green;">+ {{ trialExtended }} days</span>
            <h2 style="color: #000; margin-top: 20px; font-size: 16px; font-weight: 600; text-transform: uppercase;">Your trial has been<br/>successfully extended</h2>
            <br/><br/>
            <v-btn style="border-radius: 16px;" large class="grey lighten-3" @click="reload">
                <span style="text-transform: uppercase!important;">
                    START USING IT <v-icon style="margin-top: -2px;">chevron_right</v-icon>
                </span>
            </v-btn>
        </div>

    </div>
</template>

<style>
#trial-extended-container h3 {
    text-transform: uppercase;
    line-height: 1.2;
    font-size: 19px;
    font-weight: 800;
    margin: 0px 0 20px 0;
    color: #fff;
    text-shadow: 1px 1px 2px #000;
}
#trial-extended-container p {
    line-height: 1.3; font-size: 16px; margin-bottom: 8px; text-shadow: 1px 1px 4px #000;
}
@media all and (max-height: 650px) {
    #trial-extended-container h3 {
        font-size: 16px;
    }
    #trial-extended-container p {
        font-size: 14px;
    }
}

#trial-extended-container #trial-extend-email-input {
    margin-top: 10px!important;
}
</style>

<script>
import { callSlackWebhook } from "@/utils/webhooks/slack";
import { callSubscribeWebhook, validateEmail } from "@/utils/webhooks/newsletter";
import { trialDaysLeft } from "@/utils/iap/trial-days";
import { trialConfig } from "@/configs/trial";

export default {
    data: () => ({
        visible: false,
        email: localStorage.getItem('userEmailSend') || localStorage.getItem('userEmail') || "",
        trialExtended: 0,
        extraTrialDays: trialConfig.extraTrialDays,
        tosAccepted: false,
        showTosAcceptedWarning: false,
        processing: false,
    }),
    created() {
        this.$bus.$on('extra-trial-offer-dialog:show', () => {
            this.show();
        });
    },
    watch: {
        email() {
            // Store own email
            localStorage.setItem("userEmailSend", this.email);
        },
    },
    methods: {
        handleInputFocus() {
            const el = document.querySelector('.premium--lock-down-extendable');
            if (el) el.classList.add('focused');
        },
        handleInputBlur() {
            const el = document.querySelector('.premium--lock-down-extendable');
            if (el) el.classList.remove('focused');
        },
        reload() {
            this.$bus.$emit('trialExtended');
        },
        show() {
            if (localStorage.getItem('extendedTrial') !== null) return;
            if (window.IAP.hasPremiumAccess()) return;
            this.visible = true;

            window.Tracker.logEvent({
                event_name: "extra_trial_offer",
                event_category: "iap",
                event_label: "show",
            });
        },
        async validateEmailFormat(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        async send() {
            if (this.processing) return;
            window.Tracker.logEvent({
                event_name: "extra_trial_offer",
                event_category: "iap",
                event_label: "send",
            });
            this.processing = true;

            const isValidEmailFormat = await this.validateEmailFormat(this.email);
            if (!isValidEmailFormat) {
                this.processing = false;
                this.$refs.reviewEmail.focus();
                return;
            }

            if (!this.tosAccepted) {
                this.processing = false;
                this.$bus.$emit("app.showSnackbar", {color: "red", text: "Please accept the privacy policy", timeout: 3000});
                this.showTosAcceptedWarning = true;
                return;
            }

            const isValidEmail = await validateEmail(this.email);
            if (!isValidEmail) {
                this.processing = false;
                this.$bus.$emit("app.showSnackbar", {color: "red", text: "Please use your real email address", timeout: 3000});
                return;
            }
            callSubscribeWebhook(this.email);
            callSlackWebhook("#denticalc-registrations", "New subscriber (trial extended): " + this.email);
            this.trialExtended = this.extraTrialDays;
            //const duration = trialDaysLeft() + this.extraTrialDays;
            const duration = this.extraTrialDays;
            this.extendTrial({duration: duration});
            this.$bus.$emit('flutter:updateFirstRunTS');
            window.Tracker.logEvent({
                event_name: "extra_trial_offer",
                event_category: "iap",
                event_label: "success",
            });
            this.processing = false;
        },
        extendTrial(result) {
            const date = new Date();
            date.setDate(date.getDate() + result.duration);

            if (typeof result.sku === "string") {
                localStorage.setItem('ca_' + result.sku, String(date.getTime()))
            } else {
                localStorage.setItem('extendedTrial', String(date.getTime()));
            }
        },

    }
}
</script>
